import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { useCurrentUser } from "utils/currentUser";
import util from "utils/utils";

import { useIdea } from "../hooks/useIdea";
import { useIdeaIdState } from "../hooks/useIdea";

const IdeaHelmet = () => {
  const { t } = useTranslation();
  const user = useCurrentUser();

  const [ideaId] = useIdeaIdState();
  const [idea] = useIdea();
  return (
    <Helmet>
      <title>
        {idea ? idea.name : t("common:capitalise", { key: "generic.ideas" })}
      </title>
      <meta
        property="og:title"
        content={
          idea ? idea.name : t("common:capitalise", { key: "generic.ideas" })
        }
      />
      <meta
        property="og:description"
        content={`by ${idea?.owner?.profile?.fullName}`}
      />
      <meta
        property="og:image"
        content={util.ideaCoverImage(idea, "1280x200")}
      />
      <meta
        property="og:url"
        content={`${util.getBaseUrl(user?.ownerOrganisation)}/ideas/${ideaId}`}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@_simplydo"></meta>
      <meta
        name="twitter:url"
        content={`${util.getBaseUrl(user?.ownerOrganisation)}/ideas/${ideaId}`}
      />
      <meta
        name="twitter:title"
        content={
          idea ? idea.name : t("common:capitalise", { key: "generic.ideas" })
        }
      />
      <meta
        name="twitter:description"
        content={`by ${idea?.owner?.profile?.fullName}`}
      />
      <meta
        name="twitter:image"
        content={util.ideaCoverImage(idea, "1280x200")}
      />
    </Helmet>
  );
};

export default IdeaHelmet;
